import {
  DATE_TIME_FORMAT,
  DATE_FORMAT,
  TIME_FORMAT,
} from '../../config/locale';
import { tzNormalizeDate } from '../date';
import { numberFormatter } from '../number';
import {
  addQrCode,
  addText,
  createPdfDocument,
  paragraphSize,
  setFont,
  y,
} from '../pdf';
import { convertNumberToText, padStart } from '../string';

const myX = 3;
let myY = y;
const margin = 3;

const preFooter =
  'Luego de esta fecha, el saldo no utilizado se perderá automáticamente.';

const footer =
  'Para usar la nota de crédito el titular debe solicitar, a\n' +
  'través de uno de los siguientes canales:\n' +
  'VIRTUAL: a través del WhatsApp 986658043 o al correo\n' +
  'postventa@civa.com.pe. El horario de atención de\n' +
  'respuesta es de 7:00 am a 10:00 pm. PRESENCIAL: en\n' +
  'cualquier agencia de CIVA, portando su documento de\n' +
  'identificación (DNI / pasaporte / CE / CI) y la nota de\n' +
  'crédito.';

const qrWidth = 35;
const qrHeight = 35;

const printLine = (doc) => {
  addText(
    doc,
    '----------------------------------------------------------------------------',
    40,
    (myY += margin),
    80,
  );
};

const printCompanyFields = (doc) => {
  setFont(doc, 'bold');
  doc.setFontSize(paragraphSize);
  addText(doc, 'TURISMO CIVA S.A.C.', 40, myY, 80);
  setFont(doc);
  addText(doc, 'Si va de viaje, ¡viaje en Civa!', 40, (myY += margin), 80);
  addText(doc, 'R.U.C 20102427891', 40, (myY += margin), 80);
  addText(doc, 'JR SANCHO DE RIVERA 1184', 40, (myY += margin), 80);
  addText(doc, 'URB. MONSERRATE LIMA', 40, (myY += margin), 80);
  addText(doc, 'Central Telefónica: (511) 418-1111', 40, (myY += margin), 80);
  printLine(doc);
};

const printTicketFields = (doc, { issuingAgency, createDate, ticketCode }) => {
  const agencyNameText = doc.splitTextToSize(
    `Agencia de Emisión: ${issuingAgency}`,
    75,
  );
  agencyNameText.forEach((text) => {
    addText(doc, text, myX, (myY += margin), 75, 'left');
  });
  addText(
    doc,
    `Fecha/Hora Emisión: ${createDate}`,
    myX,
    (myY += margin),
    75,
    'left',
  );
  setFont(doc, 'bold');
  doc.setFontSize(14);

  const voucherText = doc.splitTextToSize('NOTA DE CREDITO ELECTRONICA', 75);
  voucherText.forEach((text) => {
    addText(doc, text, 40, (myY += 5), 75);
  });

  addText(doc, ticketCode, 40, (myY += 5), 75);
  doc.setFontSize(paragraphSize);
  setFont(doc);
  printLine(doc);
};

const printModifiedDocument = (
  doc,
  {
    voucherType,
    createDate,
    ticketCode,
    companyDocumentNumber,
    companyName,
    fullName,
    identificationType,
    idDocumentNumber,
    motive,
    pin,
  },
) => {
  setFont(doc, 'bold');
  addText(doc, 'DOCUMENTO QUE MODIFICA:', myX, (myY += margin * 2), 50, 'left');

  setFont(doc);
  addText(
    doc,
    `${voucherType.toUpperCase()}: ${ticketCode}`,
    myX,
    (myY += margin),
    75,
    'left',
  );

  addText(doc, `FECHA: ${createDate}`, myX, (myY += margin), 75, 'left');

  const documentTypeText = companyDocumentNumber ? 'RUC' : identificationType;
  const documentTypeValue = companyDocumentNumber || idDocumentNumber;
  addText(
    doc,
    `${documentTypeText}: ${documentTypeValue}`,
    myX,
    (myY += margin),
    75,
    'left',
  );

  const companyNameValue = companyName || fullName;
  const companyNameText = doc.splitTextToSize(
    `SEÑOR(ES): ${companyNameValue}`,
    75,
  );
  companyNameText.forEach((text) => {
    addText(doc, text, myX, (myY += margin), 75, 'left');
  });

  addText(doc, `TIPO DE MONEDA: SOLES`, myX, (myY += margin), 75, 'left');

  if (motive)
    addText(
      doc,
      `SUSTENTO: ${motive.toUpperCase()}`,
      myX,
      (myY += margin),
      75,
      'left',
    );

  addText(doc, `PIN: ${pin}`, myX, (myY += margin), 75, 'left');

  printLine(doc);
};

const printPaymentFields = (
  doc,
  {
    ticketPrice,
    ticketPriceString,
    paymentMethod,
    userName,
    creditNoteExpirationDate,
  },
) => {
  setFont(doc, 'bold');
  addText(doc, 'DATOS DE PAGO:', myX, (myY += margin * 2), 75, 'left');
  setFont(doc);
  addText(doc, 'OP. GRAVADA', myX, (myY += margin), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);
  addText(doc, 'OP. GRATUITO', myX, (myY += margin), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);
  addText(doc, 'OP. EXONERADO', myX, (myY += margin), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: ticketPrice })}`, myX + 34, myY);
  addText(doc, 'OP. INAFECTO', myX, (myY += margin), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);
  addText(doc, 'IGV', myX, (myY += margin), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: 0 })}`, myX + 34, myY);
  addText(doc, 'IMPORTE TOTAL', myX, (myY += margin), 75, 'left');
  addText(doc, `: ${numberFormatter({ value: ticketPrice })}`, myX + 34, myY);
  addText(doc, 'Son:', myX, (myY += margin), 10, 'left');
  const ticketPriceStringText = doc.splitTextToSize(ticketPriceString, 75);
  ticketPriceStringText.forEach((text, index) => {
    addText(doc, text, myX + 6, (myY += index === 0 ? 0 : margin), 75, 'left');
  });
  addText(doc, 'Tipo de Pago', myX, (myY += margin), 75, 'left');
  addText(doc, ':', myX + 34, myY);
  const paymentMethodText = doc.splitTextToSize(paymentMethod, 40);
  paymentMethodText.forEach((text, index) => {
    addText(doc, text, myX + 36, (myY += index === 0 ? 0 : margin), 40, 'left');
  });
  addText(doc, 'Numero Tarjeta', myX, (myY += margin), 75, 'left');
  addText(doc, `: -`, myX + 34, myY);
  addText(doc, 'Numero Voucher', myX, (myY += margin), 75, 'left');
  addText(doc, `: -`, myX + 34, myY);
  addText(doc, 'Usuario', myX, (myY += margin), 75, 'left');
  addText(doc, ':', myX + 34, myY);
  const userNameText = doc.splitTextToSize(userName, 40);
  userNameText.forEach((text, index) => {
    addText(doc, text, myX + 36, (myY += index === 0 ? 0 : margin), 40, 'left');
  });

  setFont(doc, 'bold');
  doc.setFontSize(14);
  myY += 10;
  addText(doc, 'Esta nota de crédito es válida', 40, myY, 80);
  addText(doc, `hasta el ${creditNoteExpirationDate}`, 40, (myY += 5.5), 80);
  doc.setFontSize(paragraphSize);
  addText(doc, preFooter, myX, (myY += margin * 2), 74, 'justify');

  // menos espacio (en tu imagen no baja tanto)
  myY += 4;

  setFont(doc);

  // respeta los saltos de línea y ajusta cada línea al ancho
  footer.split('\n').forEach((line) => {
    const wrapped = doc.splitTextToSize(line, 74);
    // eslint-disable-next-line no-return-assign
    wrapped.forEach((t) => addText(doc, t, myX, (myY += margin), 74, 'left'));
  });
  addText(
    doc,
    'Representación impresa de la Nota de Crédito',
    40,
    (myY += margin * 2),
    74,
    'center',
  );
};

const addTicket = async (
  doc,
  {
    ticketFields: { issuingAgency, createDate, ticketCode, voucherType },
    creditNoteFields: {
      creditNoteCode,
      creditNoteCreateDate,
      pin,
      creditNoteExpirationDate,
    },
    paymentFields: {
      ticketPrice,
      ticketPriceString,
      paymentMethod,
      userName,
      companyDocumentNumber = null,
      companyName = null,
      motive = null,
    },
    passengerFields: { fullName, identificationType, idDocumentNumber },
  },
) => {
  await addQrCode(doc, ticketCode, 22.5, 0, qrWidth, qrHeight);
  myY += 32;
  printCompanyFields(doc);
  printTicketFields(doc, {
    issuingAgency,
    createDate: creditNoteCreateDate,
    ticketCode: creditNoteCode,
  });
  printModifiedDocument(doc, {
    voucherType,
    createDate,
    ticketCode,
    companyDocumentNumber,
    companyName,
    fullName,
    identificationType,
    idDocumentNumber,
    motive,
    pin,
  });
  printPaymentFields(doc, {
    ticketPrice,
    ticketPriceString,
    paymentMethod,
    userName,
    creditNoteExpirationDate,
  });
  myY = 5;
};

const formatTicketWithCreditNote = (ticket, creditNote) => {
  const transaction = ticket.transactions[0];
  const voucherPrefix = transaction.business ? 'F' : 'B';

  return {
    ticketFields: {
      issuingAgency: `${ticket.agency.name}\n${ticket.agency.address}`,
      createDate: tzNormalizeDate({
        date: ticket.documentAssignmentDate,
        format: DATE_TIME_FORMAT,
      }),
      voucherType: transaction.voucherType.name,
      ticketCode: ticket.fullDocumentCode,
    },

    creditNoteFields: creditNote
      ? {
          creditNoteCreateDate: tzNormalizeDate({
            date: creditNote.createDate,
            format: DATE_TIME_FORMAT,
          }),
          creditNoteCode: `${
            voucherPrefix + creditNote.documentSeries
          }-${padStart(creditNote.documentCode, 7)}`,
          pin: creditNote.reference,
          creditNoteExpirationDate: tzNormalizeDate({
            date: creditNote.expirationDate,
            format: DATE_FORMAT,
          }),
        }
      : {
          creditNoteCreateDate: '-',
          creditNoteCode: '-',
          pin: '-',
          creditNoteExpirationDate: '-',
        },

    tripFields: {
      origin: ticket.sourceLocation.name,
      boarding: ticket.sourceLocation.name,
      boardingAddress: ticket.sourceLocation.address,
      disembarking: ticket.destinationLocation.name,
      destination: ticket.destinationLocation.name,
      disembarkingAddress: ticket.destinationLocation.address,
      tripDate: tzNormalizeDate({
        date: ticket.departureDate,
        format: DATE_FORMAT,
      }),
      tripTime: tzNormalizeDate({
        date: ticket.departureDate,
        format: TIME_FORMAT,
      }),
    },

    passengerFields: {
      fullName: ticket.customer.fullName,
      identificationType: ticket.customer.identificationType.name,
      idDocumentNumber: ticket.customer.idDocumentNumber,
    },

    paymentFields: {
      ticketPrice:
        creditNote && creditNote.amount !== 0
          ? creditNote.amount
          : ticket.salePrice,

      ticketPriceString:
        creditNote && creditNote.amount !== 0
          ? convertNumberToText(creditNote.amount, true)
          : ticket.salePriceString,

      paymentMethod: transaction.paymentMethod.name,
      userName: ticket.user.customer.fullName,
      companyDocumentNumber: transaction.business
        ? transaction.business.businessTaxId
        : undefined,
      companyName: transaction.business ? transaction.business.name : undefined,
      motive:
        creditNote && creditNote.motive
          ? creditNote.motive
          : 'Anulación de la Operación',
    },
  };
};

const printCreditNotes = async (ticket) => {
  const doc = createPdfDocument('p', 'mm', [80, 230]);

  const creditNotes = (ticket.creditNoteList || [])
    .slice()
    .sort((a, b) => new Date(a.createDate) - new Date(b.createDate));

  const listToPrint =
    creditNotes.length > 0 ? creditNotes : [ticket.creditNote || null];

  for (let i = 0; i < listToPrint.length; i += 1) {
    const cn = listToPrint[i];
    const formatted = formatTicketWithCreditNote(ticket, cn);

    myY = 5;

    // eslint-disable-next-line no-await-in-loop
    await addTicket(doc, formatted);

    if (i < listToPrint.length - 1) {
      doc.addPage([80, 230], 'p');
      myY = 5;
    }
  }

  doc.autoPrint();
  window.open(doc.output('bloburl'), '_blank');
};

const getLatestCreditNote = (ticket) => {
  if (ticket.creditNoteList && ticket.creditNoteList.length > 0) {
    const sorted = ticket.creditNoteList
      .slice()
      .sort((a, b) => new Date(b.createDate) - new Date(a.createDate));

    return sorted[0];
  }

  // fallback legacy
  if (ticket.creditNote) return ticket.creditNote;

  return null;
};

const getLatestTransaction = (parcel) => {
  if (parcel.transactionList) {
    const sorted = Array.from(parcel.transactionList)
      .slice()
      .sort((a, b) => a.id - b.id);

    return sorted[0];
  }

  return null;
};

const formatCargoTicket = (parcel) => {
  const transaction = getLatestTransaction(parcel);
  const voucherPrefix = transaction.business ? 'F' : 'B';

  const latestCreditNote = getLatestCreditNote(parcel);

  const formatedParcel = {
    ticketFields: {
      issuingAgency: `${parcel.agency.name}\n${parcel.agency.address}`,
      createDate: tzNormalizeDate({
        date: parcel.createDate,
        format: DATE_TIME_FORMAT,
      }),
      voucherType: transaction.voucherType.name,
      ticketCode: `${parcel.documentSeries}-${padStart(
        parcel.documentCode,
        7,
      )}`,
    },
    creditNoteFields: latestCreditNote
      ? {
          creditNoteCreateDate: tzNormalizeDate({
            date: latestCreditNote.createDate,
            format: DATE_TIME_FORMAT,
          }),
          creditNoteCode: `${voucherPrefix}${
            latestCreditNote.documentSeries
          }-${padStart(latestCreditNote.documentCode, 7)}`,
          pin: latestCreditNote.reference,
          creditNoteExpirationDate: tzNormalizeDate({
            date: latestCreditNote.expirationDate,
            format: DATE_FORMAT,
          }),
        }
      : {
          creditNoteCreateDate: '-',
          creditNoteCode: '-',
          pin: '-',
          creditNoteExpirationDate: '-',
        },
    passengerFields: {
      fullName: parcel.customer
        ? parcel.customer.fullName
        : parcel.business.name,
      identificationType: parcel.customer
        ? parcel.customer.identificationType.name
        : null,
      idDocumentNumber: parcel.customer
        ? parcel.customer.idDocumentNumber
        : parcel.business.businessTaxId,
    },
    paymentFields: {
      ticketPrice: latestCreditNote
        ? latestCreditNote.amount
        : parcel.salePrice,

      ticketPriceString: convertNumberToText(latestCreditNote.amount, true),

      paymentMethod: transaction.paymentMethodName,
      userName: parcel.user.customer.fullName,
      companyDocumentNumber: transaction.business
        ? transaction.business.businessTaxId
        : undefined,
      companyName: transaction.business ? transaction.business.name : undefined,
      // TODO active is necessary
      // motive: ticket.ticketVoid ? ticket.ticketVoid.description : undefined,
      motive:
        latestCreditNote && latestCreditNote.motive
          ? latestCreditNote.motive
          : 'Anulación de la Operación',
    },
  };
  return formatedParcel;
};

const printParcelCreditNote = async (parcel) => {
  const doc = createPdfDocument('p', 'mm', [80, 230]);
  const formattedTicket = formatCargoTicket(parcel);
  await addTicket(doc, formattedTicket);
  doc.autoPrint();
  window.open(doc.output('bloburl'), '_blank');
};

export { printCreditNotes, printParcelCreditNote };
